import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';

const getApiService = () => `${apiUtils.getBaseUri()}/users`;

const doRegister = async registrationDTO => {
    const uri = `${getApiService()}`;
    const response = await HTTPClient().postJson(uri, registrationDTO);
    const resBody = await response.json();

    if (!response.ok) {
        throw {
            json: resBody,
            status: response.status,
            message: response.message,
        };
    }
    return resBody;
};

const getPrefillInformation = async data => {
    const uri = `${apiUtils.getBaseUri()}/forms/prefill`;
    const response = await HTTPClient().postJson(uri, data);
    if (!response.ok) {
        throw new Error(`Unable to load address suggestions (${response.status})`);
    }
    const contentLength = parseInt(response.headers.get('Content-Length'));

    if (contentLength) {
        return await response.json();
    }
};

const verifyUserByPhone = async ({ phone, phoneVerificationSessionId }) => {
    const uri = `${apiUtils.getBaseUri()}/loyalty-card/phoneNumber`;
    const body = {
        phoneNumber: phone,
        phoneVerificationSessionId,
    };
    const response = await HTTPClient().postJson(uri, body);
    const resBody = await response.json();

    return resBody;
};

export default {
    doRegister,
    getPrefillInformation,
    verifyUserByPhone,
};
